<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="The Illustrated Book Of Edible Plants"><div class="frontmatter"><div class="recto"><h1 class="title"><a id="index"></a>The Illustrated Book Of
                        Edible Plants</h1><h3 class="author">Jack Staub, Proprietor Hortulus
                        Farm</h3><h4>Illustrations by Ellen Sheppard Buchert </h4><img alt="Gibbs Smith Logo" src="images/logo.jpg"/></div><div class="verso"><p class="versotitle">The Illustrated Book Of Edible Plants</p><p>Digital
                        Edition 1.0</p><p class="copyright">Text © 2016 Jack
                        Staub</p><p>Illustrations © 2016 Ellen Sheppard Buchert</p><p>All rights
                        reserved. No part of this book may be reproduced by any means whatsoever
                        without written permission from the publisher, except brief portions quoted
                        for purpose of review.</p><p class="nobreak">Gibbs Smith</p><p class="nobreak">P.O. Box 667</p><p>Layton, Utah 84041</p><p class="nobreak">Orders: 1.800.835.4993</p><p>www.gibbs-smith.com</p><p>ISBN:
                        9781423646754</p></div></div><div class="frontmatter"></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?572df0fc